function addZeroes(num) {
  return num.toFixed(Math.max((`${num}`.split(".")[1] || "").length, 2));
}

export default addZeroes;



// WEBPACK FOOTER //
// ./src/utils/addZeroes.js